import React from "react";

const DEFAULT_PRIMARY_BTN_CLASS =
  "min-h-[40px] w-full rounded-[11px] bg-[#A1A3EF] px-4 py-2 text-[14px] text-[#FFFFFF] shadow-lg cursor-pointer transition hover:shadow-xl";

const DEFAULT_SECONDARY_BTN_CLASS =
  "appearance-none cursor-pointer border-0 !bg-transparent text-center text-[14px] text-[#5B5FC7] underline";

const ReuseablePopup = ({
  setShowPopup,
  heading,
  text,
  btnText,
  onClick,
  imageSrc,
  imageAlt = "popup-visuals",
  secondaryBtnText,
  onSecondaryClick,
  primaryButtonClassName,
  secondaryButtonClassName,
}) => {
  const closePopup = () => {
    setShowPopup(false);
  };

    return (
      <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="w-[360px] flex flex-col justify-center items-center relative rounded-[23px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg">
          <div className="absolute top-2 right-2">
            <img
              className="absolute right-3 top-[6px] cursor-pointer"
              src={require("./Assets/Cross.svg").default}
              alt="Close"
              onClick={closePopup}
            />
          </div>

          {imageSrc && (
            <img
              src={imageSrc}
              alt={imageAlt}
              className="mb-2 mt-[-60px]"
            />
          )}
          <h2 className="mt-[10px] mb-[10px] text-center text-[16px] font-semibold">
             {heading}
          </h2>
          <p className="text-center text-[14px] w-[280px]">{text}</p>
          <div className="mt-[40px] flex w-full flex-col items-center justify-center gap-3">
            <button
              type="button"
              className={
                primaryButtonClassName != null
                  ? primaryButtonClassName
                  : DEFAULT_PRIMARY_BTN_CLASS
              }
              onClick={onClick}
            >
              {btnText}
            </button>
            {secondaryBtnText && typeof onSecondaryClick === "function" ? (
              <button
                type="button"
                className={
                  secondaryButtonClassName != null
                    ? secondaryButtonClassName
                    : DEFAULT_SECONDARY_BTN_CLASS
                }
                onClick={onSecondaryClick}
              >
                {secondaryBtnText}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

export default ReuseablePopup;
